import { render, staticRenderFns } from "./beneficios.vue?vue&type=template&id=06aa64ac&scoped=true&"
import script from "./beneficios.vue?vue&type=script&lang=js&"
export * from "./beneficios.vue?vue&type=script&lang=js&"
import style0 from "./beneficios.vue?vue&type=style&index=0&id=06aa64ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aa64ac",
  null
  
)

export default component.exports